import type { CSSProperties } from "react";
import {
  chartCardShellClass,
  chartCardShellStyle } from
"~/components/charts/UI/chartCardStyle";

/**
 * Card shell for insurance surfaces. Sourced from the shared `charts/UI`
 * library so insurance cards stay visually identical to dashboard chart cards
 * (`ChartContainer`) and the shell isn't duplicated here.
 */
export const insuranceCardClass = chartCardShellClass;

/** Brand gradient + shadow — re-exported from the shared chart card shell. */
export const insuranceCardStyle = chartCardShellStyle;

export const insuranceCardPadding = "p-4";
export const insuranceCardPaddingLg = "p-5";

/**
 * Refined card surface — a softer alternative to the brand `border-2 border-primary`
 * shell. Uses a hairline low-opacity border and a diffuse, low-contrast shadow so
 * dense content (e.g. the coverage checklist) reads as a calm, elevated surface
 * rather than a hard-outlined box.
 */
export const insuranceRefinedCardClass =
"overflow-hidden rounded-2xl border border-primary/10 dark:border-white/10";

export const insuranceRefinedCardStyle: CSSProperties = {
  boxShadow:
  "0px 1px 2px rgb(var(--color-secondary) / 0.06), 0px 8px 24px -8px rgb(var(--color-secondary) / 0.12)",
  background:
  "linear-gradient(180deg, rgb(var(--color-primary) / 0.035) 0%, rgb(var(--color-primary) / 0) 55%), var(--chart-container-bg, #FFFFFF)"
};

/** Numeric values — brand menu color (#142F40) */
export const insuranceNumberClass = "text-menu";

/** Summary cube icon — matches cashflowSummary row shells */
export const insuranceSummaryIconShellClass =
"flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-gray-200/80 bg-gray-50 shadow-sm dark:border-[#3e3e56] dark:bg-[#28283c] dark:shadow-none";

/** Company / fallback icon — see `.insurance-logo-shell` in global.css */
export const insuranceLogoShellClass = "insurance-logo-shell";

export const insuranceLogoImageClass = "dark-no-filter";